<template>
  <router-view />
</template>
<script>
export default {
  name: "app",
  created() {
    // remove appLoading dom from body
    let spiner = document.getElementById("spiner");
    if (spiner) {
      // spiner.setAttribute("class", "hide");
      setTimeout(() => {
        document.body.removeChild(spiner);
        var style = document.getElementsByTagName("style")[0];
        document.head.removeChild(style);
      }, 350);
    }
  },
};
</script>